import { gql } from '@apollo/client';
import minimalCompanyFragment from '../fragments/minimalCompanyFragment';

export default gql`
  mutation createCompany($input: CompanyInput!) {
    createCompany(input: $input) {
      ...minimalCompanyFragment
    }
  }
  ${minimalCompanyFragment}
`;
